import { Badge, Tabs } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { PERMISSIONS_KEY, ROUTES, TABS } from '../../../../../common/constants';
import { filterTabsByPermissions } from '../../../../../common/utils';

const NewTabs = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const {
    state: { permissions, orderCount },
  } = useContext(AppContext);
  const [activeTabKey, setActiveTabKey] = useState(TABS?.DELIVERY?.key);

  const blinkingDotEl = useMemo(
    () => <Badge status="processing" color="red" className="custom-badge" />,
    [],
  );
  const tabList = [
    {
      key: TABS?.CONFIRM_ORDER?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.CONFIRM_ORDER?.label} ${
            orderCount?.newOrderCount || orderCount?.newOrderCount === 0
              ? `(${orderCount?.newOrderCount})`
              : ''
          } `}
          {orderCount?.placedOrderCount > 0 ? blinkingDotEl : null}
        </div>
      ),
      children,
      permissionKey: PERMISSIONS_KEY?.ORDERS_NEW_PLACED,
    },
    {
      key: TABS?.FULFILMENT_POSSIBILITY?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.FULFILMENT_POSSIBILITY?.label} ${
            orderCount?.fulfilmentPossibilityOrderCount || orderCount?.fulfilmentPossibilityOrderCount === 0
              ? `(${orderCount?.fulfilmentPossibilityOrderCount})`
              : ''
          } `}
          {orderCount?.fulfilmentPossibilityOrderCount > 0 ? blinkingDotEl : null}
        </div>
      ),
      children,
      permissionKey:
        permissions?.[PERMISSIONS_KEY?.ORDERS_NEW_FULFILMENT_POSSIBILITY]?.length > 0
          ? PERMISSIONS_KEY?.ORDERS_NEW_FULFILMENT_POSSIBILITY
          : PERMISSIONS_KEY?.ORDERS_NEW_PLACED,
    },
    {
      key: TABS?.ASSIGN_DELIVERY_PARTNER?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.ASSIGN_DELIVERY_PARTNER?.label} ${
            orderCount?.confirmedOrderCount ||
            orderCount?.confirmedOrderCount === 0
              ? `(${orderCount?.confirmedOrderCount})`
              : ''
          } `}
          {orderCount?.remainingConfirmedOrderCount > 0 ? blinkingDotEl : null}
        </div>
      ),
      children,
      permissionKey: PERMISSIONS_KEY?.ORDERS_NEW_CONFIRMED,
    },
    {
      key: TABS?.RETURN?.key,
      label: (
        <div className="d-flex align-center gap-10">
          {`${TABS?.RETURN?.label} ${
            orderCount?.returnOrderCount || orderCount?.returnOrderCount === 0
              ? `(${orderCount?.returnOrderCount})`
              : ''
          } `}
          {orderCount?.returnRequestedOrderCount > 0 ? blinkingDotEl : null}
        </div>
      ),
      children,
      permissionKey: PERMISSIONS_KEY?.ORDERS_NEW_RETURN,
    },
  ];

  const filteredTabs = filterTabsByPermissions(tabList, permissions);

  useEffect(() => {
    if (location?.pathname?.includes(ROUTES?.CONFIRM_ORDER)) {
      setActiveTabKey(TABS?.CONFIRM_ORDER?.key);
    }
    if (location?.pathname?.includes(ROUTES?.FULFILMENT_POSSIBILITY)) {
      setActiveTabKey(TABS?.FULFILMENT_POSSIBILITY?.key);
    }
    if (location?.pathname?.includes(ROUTES?.ASSIGN_DELIVERY_PARTNER)) {
      setActiveTabKey(TABS?.ASSIGN_DELIVERY_PARTNER?.key);
    }
    if (location?.pathname?.includes(ROUTES?.DELIVERY)) {
      setActiveTabKey(TABS?.DELIVERY?.key);
    }
    if (location?.pathname?.includes(ROUTES?.RETURN)) {
      setActiveTabKey(TABS?.RETURN?.key);
    }
  }, [location]);

  const onTabChange = (key) => {
    setActiveTabKey(key);
    switch (key) {
      case TABS?.CONFIRM_ORDER?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.CONFIRM_ORDER}`,
        );
        break;
      case TABS?.FULFILMENT_POSSIBILITY?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.FULFILMENT_POSSIBILITY}`,
        );
        break;
      case TABS?.ASSIGN_DELIVERY_PARTNER?.key:
        history?.push(
          `${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.ASSIGN_DELIVERY_PARTNER}`,
        );
        break;
      case TABS?.DELIVERY?.key:
        history?.push(`${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.DELIVERY}`);
        break;
      case TABS?.RETURN?.key:
        history?.push(`${ROUTES?.ORDERS}${ROUTES?.NEW}${ROUTES?.RETURN}`);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="card-container">
        <Tabs
          activeKey={activeTabKey}
          type="card"
          className="full-width"
          onChange={(key) => onTabChange(key)}
          items={filteredTabs}
          destroyInactiveTabPane
        />
      </div>
    </>
  );
};

export default NewTabs;
